export default "__VITE_ASSET__569dcaaf__"